import { useState } from 'react';
import { paginationData } from '@shared/lib/utils/pagination/pagination';
import { Pagination, PaginationParametersRequest } from '@shared/model/common';

export const usePagination = ({ skip, take, total }: Pagination) => {
    const { maxPage, currentPage, validTake } = paginationData({
        skip,
        take,
        total,
    });

    const [defaultTake, ,] = useState(take);

    const paginationParameters = ({ page, elementsOnPage }: { page?: number; elementsOnPage?: number }) => {
        const result: PaginationParametersRequest = { skip, take };
        if (page !== currentPage && page) {
            result.skip = (page - 1) * validTake || null;
        }
        if (elementsOnPage !== take && elementsOnPage) {
            result.take = elementsOnPage;
            result.skip = null;
        }
        return result;
    };

    return {
        maxPage,
        currentPage,
        paginationParameters,
        isHiddenPagination: (defaultTake && total <= defaultTake) || !defaultTake,
    };
};
